const clearStyle = (dom) => {
  const p = dom.querySelectorAll('p');
  const span = dom.querySelectorAll('span');
  const font = dom.querySelectorAll('font');
  const img = dom.querySelectorAll('img');

  // eslint-disable-next-line no-restricted-syntax
  for (const item of p.values()) {
    item.style.fontSize = '';
    item.style.lineHeight = '';
    item.style.fontFamily = '';
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const item of span.values()) {
    item.style.fontSize = '';
    item.style.lineHeight = '';
    item.style.fontFamily = '';
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const item of font.values()) {
    item.size = '';
    item.face = '微软雅黑';
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const item of img.values()) {
    // item.width = "100%";
    item.style.width = '100%';
    item.style.height = 'auto';

    if (item.getAttribute('src') === '' || !item.src) { item.setAttribute('src', item.getAttribute('data-cfsrc') || item.getAttribute('oldsrc')); }
    // item.height = "auto";
    item.parentNode.parentNode.style.textIndent = '';
    if (item.style.display === 'none') item.style.display = '';
    if (item.style.visibility === 'hidden') item.style.visibility = '';
  }
  return dom;
};

// eslint-disable-next-line import/prefer-default-export
export { clearStyle };
